module.exports = __webpack_public_path__ + "static/media/round.c9af8efe.png";